export default __webpack_public_path__ + "static/media/SharpGroteskSmBold15.89fab1b9.woff2";